import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  TrackSubscriptionCanceledEventAction,
  TrackSubscriptionDowngradedCanceledEventAction,
  TrackSubscriptionUnCanceledEventAction,
  TrackUserLoggedInEventAction,
  TrackUserRegisteredEventAction,
} from './tracking.actions';
import { Tracker, TrackingService } from './tracking.service';

export type TrackingStateModel = object;

@State<TrackingStateModel>({
  name: 'tracking',
  defaults: {},
})
@Injectable()
export class TrackingState {
  private trackingService = inject(TrackingService);

  @Action(TrackUserLoggedInEventAction)
  async trackUserLoggedInEvent(
    ctx: StateContext<TrackingStateModel>,
    { identityId, method }: TrackUserLoggedInEventAction
  ) {
    await this.trackingService.trackEvent(
      {
        event: 'incidite_user_logged_in',
        data: {
          userId: identityId,
          method: method,
        },
      },
      { trackers: [Tracker.GTM, Tracker.POSTHOG] }
    );
  }

  @Action(TrackUserRegisteredEventAction)
  async trackUserRegisteredEvent(
    ctx: StateContext<TrackingStateModel>,
    { identityId, method }: TrackUserRegisteredEventAction
  ) {
    await this.trackingService.trackEvent(
      {
        event: 'incidite_user_registered',
        data: {
          userId: identityId,
          method: method,
        },
      },
      { trackers: [Tracker.GTM, Tracker.POSTHOG] }
    );
  }

  @Action(TrackSubscriptionCanceledEventAction)
  async trackSubscriptionCanceledEvent(
    ctx: StateContext<TrackingStateModel>,
    { planName }: TrackSubscriptionCanceledEventAction
  ) {
    await this.trackingService.trackEvent(
      {
        event: 'incidite_subscription_canceled',
        data: {
          planName: planName,
        },
      },
      { trackers: [Tracker.GTM, Tracker.POSTHOG] }
    );
  }

  @Action(TrackSubscriptionUnCanceledEventAction)
  async trackSubscriptionUnCanceledEvent(
    ctx: StateContext<TrackingStateModel>,
    { planName }: TrackSubscriptionUnCanceledEventAction
  ) {
    await this.trackingService.trackEvent(
      {
        event: 'incidite_subscription_uncanceled',
        data: {
          planName: planName,
        },
      },
      { trackers: [Tracker.GTM, Tracker.POSTHOG] }
    );
  }

  @Action(TrackSubscriptionDowngradedCanceledEventAction)
  async trackSubscriptionDowngradedCanceledEvent(
    ctx: StateContext<TrackingStateModel>,
    { planName }: TrackSubscriptionDowngradedCanceledEventAction
  ) {
    await this.trackingService.trackEvent(
      {
        event: 'incidite_subscription_downgrade_canceled',
        data: {
          planName: planName,
        },
      },
      { trackers: [Tracker.GTM, Tracker.POSTHOG] }
    );
  }
}
